import { Component, Host, h, Prop, Element } from "@stencil/core";
import { MercuryBundles } from "@genexus/mercury";

const CSS_BUNDLES: MercuryBundles = [
  "resets/box-sizing",
  "components/button",
  "components/icon",
  "utils/typography"
];

@Component({
  tag: "gx-ide-empty-state",
  styleUrl: "gx-ide-empty-state.scss",
  shadow: true
})
export class GxIdeEmptyState {
  @Element() el: HTMLGxIdeEmptyStateElement;

  /**
   * Includes a subtle entry animation
   */
  // eslint-disable-next-line @stencil-community/reserved-member-names
  @Prop() readonly isAnimated: boolean = false;

  /**
   * The state description
   */
  @Prop() readonly stateDescription?: string;

  /**
   * The state icon
   */
  @Prop() readonly stateIconSrc?: string;

  /**
   * The state title
   */
  @Prop() readonly stateTitle!: string;

  render() {
    return (
      <Host class={{ animate: this.isAnimated }}>
        <ch-theme model={CSS_BUNDLES}></ch-theme>
        <article class="main-container">
          {this.stateIconSrc && (
            <span class="main-container__icon-wrapper">
              <ch-image src={this.stateIconSrc} class="icon-m"></ch-image>
            </span>
          )}
          <div class="main-container__content">
            {this.stateTitle && (
              <h2 class="body-regular-m">{this.stateTitle}</h2>
            )}
            {this.stateDescription && (
              <p class="body-regular-s description">{this.stateDescription}</p>
            )}
          </div>
          <slot></slot>
        </article>
      </Host>
    );
  }
}
